import { Component, ElementRef, Inject, ViewChild, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { toPng } from 'html-to-image';
import { ITextConfig } from '../../Interfaces';

export interface IDialogResult {
  image: HTMLImageElement;
  config: ITextConfig;
}

@Component({
  selector: 'app-text-edit-dialog',
  templateUrl: 'text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent {
  config: ITextConfig;
  needArrow: boolean = false;

  @ViewChild('editorElement') editorElement: ElementRef;
  @ViewChild('sizeCalculationDiv') sizeCalculationDiv: ElementRef;

  fontSizes: number[] = Array.from({ length: 53 }, (el, index) => 8 + index);

  fonts: string[] = [
    'Arial',
    'Tahoma',
    'Verdana',
    'Courier New',
    'Lucida Console',
    'Times New Roman',
    'Georgia'
  ];

  colors: string[] = [
    '#000000',
    '#ffffff',
    '#61BD6D',
    '#1ABC9C',
    '#54ACD2',
    '#2C82C9',
    '#9365B8',
    '#475577',
    '#F7DA64',
    '#FBA026',
    '#EB6B56',
    '#E25041',
    '#A38F84',
    '#EFEFEF',
    '#FAC51C',
    '#F37934',
    '#D14841',
    '#B8312F',
    '#7C706B',
    '#D1D5D8',
    '#CCCCCC'
  ];

  constructor(
    private dialogRef: MatDialogRef<TextEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ITextConfig | null,
    private renderer: Renderer2
  ) {
    this.config = {
      fontFamily: this.fonts[0],
      textColor: this.colors[0],
      html: '',
      fontSize: 14,
      italic: false,
      underline: false,
      bold: false,
      needArrow: false
    };
    if (data) {
      Object.assign(this.config, data);
    }
    this.needArrow = this.config.needArrow;
  }

  makeBold() {
    this.config.bold = !this.config.bold;
  }

  makeItalic() {
    this.config.italic = !this.config.italic;
  }

  makeUnderline() {
    this.config.underline = !this.config.underline;
  }

  setColor(color: string) {
    this.config.textColor = color;
  }

  getStyles() {
    return {
      'font-weight': this.config.bold ? 'bold' : 'normal',
      'text-decoration': this.config.underline ? 'underline' : 'none',
      'font-style': this.config.italic ? 'italic' : 'normal',
      'font-family': this.config.fontFamily,
      color: this.config.textColor,
      'font-size': this.config.fontSize + 'px'
    };
  }

  async apply() {
    const node = this.editorElement.nativeElement;
    const innerHTML = node.innerHTML;
    // sizeCalculationDiv.innerHTML = innerHTML;
    // node.clientWidth *= 6;
    // node.style.fontSize = this.config.fontSize * 6 + 'px';

    // sizeCalculationDiv.style.fontSize = this.config.fontSize * 6 + 'px';
    // const size = sizeCalculationDiv.getBoundingClientRect();
    const sizeCalculationDiv = this.sizeCalculationDiv.nativeElement;

    // create new dow element for render scale text font size
    let domElmTextScale = this.renderer.createElement('div');
    domElmTextScale.innerHTML = innerHTML;
    let styles = this.getStyles();
    styles['font-size'] = this.config.fontSize * 6 + 'px';
    Object.assign(domElmTextScale.style, styles);
    domElmTextScale.style.maxWidth = node.clientWidth * 6 + 'px';
    this.renderer.appendChild(sizeCalculationDiv, domElmTextScale);
    const size = domElmTextScale.getBoundingClientRect();
    // console.log(size);

    const dataUrl = await toPng(domElmTextScale, {
      width: size.width || 10,
      height: size.height || 10
    });
    const image = new Image();
    image.src = dataUrl;
    this.config.needArrow = this.needArrow;

    const result: IDialogResult = {
      image,
      config: {
        ...this.config,
        html: innerHTML
      }
    };
    this.dialogRef.close(result);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/ng-components/text-editor/text-editor.component.ts